import api from '../instance'

export function getMonthDetails(date, option) {
  return api.get(`/monthlyDetails?filter=${option}`, {
    params: { date, isPMO: true },
  })
}
